export enum ObjectStatus {
  NotActive = 0,
  Active = 1,
  Deleted = 10,
  Archived = 20,
  Unknown = 999,
}

export enum AiObjectStatus {
  Paused = 'Paused',
  Active = 'Active',
  Deleted = 'Deleted',
  Archived = 'Archived',
  Unknown = 'Unknown',
}

export const objectStatusName: Record<ObjectStatus, string> = {
  [ObjectStatus.NotActive]: 'Paused',
  [ObjectStatus.Active]: 'Active',
  [ObjectStatus.Deleted]: 'Deleted',
  [ObjectStatus.Archived]: 'Archived',
  [ObjectStatus.Unknown]: 'Unknown',
};

export default ObjectStatus;
